<script>
import baseMixin from '@/mixins/baseMixin'
import CommentList from '@/components/comments/comment-list.vue'
import { mapGetters } from 'vuex'
import timesheetMixin from '@/mixins/timesheetMixin'
import { orderBy } from 'lodash'
import DisputeHistoryCommentFactory from '@/services/comments/disputeHistoryCommentFactory'
import DisputeDialogBookingHistorySubmissionAlert from './dispute-dialog-booking-history-submission-alert.vue'

export default {
  name: 'DisputeDialogBookingHistory',
  components: { CommentList, DisputeDialogBookingHistorySubmissionAlert },
  mixins: [baseMixin, timesheetMixin],
  computed: {
    ...mapGetters({
      /**
       * @type {DisputeDetailsResolutionView}
       */
      timesheet: 'disputes/activeTimesheet',
      resolveStatus: 'disputes/resolveStatus',
    }),
    /**
     * @returns {Array<CommentModel>}
     */
    compBookingHistoryComments() {
      const submissionList = this.determineTimesheetSubmissionOrder(
        this.timesheet
      )

      const factory = new DisputeHistoryCommentFactory(
        this.timesheet,
        submissionList[0].type
      )

      const submissionListByDateDesc = orderBy(submissionList, 'date', 'desc')

      return submissionListByDateDesc
        .filter(({ hidden }) => !hidden)
        .map(({ type }) => factory.createComment(type))
    },
  },
}
</script>

<template>
  <CommentList
    :title="$t('dispute.history.title')"
    :comments="compBookingHistoryComments"
  >
    <template v-slot:prepend>
      <DisputeDialogBookingHistorySubmissionAlert />
    </template>
  </CommentList>
</template>

<style>
.dispute-history-comment-actions {
  min-height: 100px;
}
</style>
